const monthLabels = [
  ['Januari', 'jan'],
  ['Februari', 'feb'],
  ['Maart', 'mrt'],
  ['April', 'apr'],
  ['Mei', 'mei'],
  ['Juni', 'jun'],
  ['Juli', 'jul'],
  ['Augustus', 'aug'],
  ['September', 'sep'],
  ['Oktober', 'okt'],
  ['November', 'nov'],
  ['December', 'dec'],
];

const dayLabels = ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'];

export const useCalendarDefaults = () => {
  return {
    monthLabels,
    dayLabels,
  };
};
